import React, { useEffect } from "react";
import { BasePage } from "../../pages/Staff/BasePage";
import { Spin } from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UnAuthenticatedPage from "../AuthPages/UnAuthenticatedPage";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getUserSettings } from "../../services/userService";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import {
  setSettings,
  initializeUserSettings,
} from "../../redux/reduxSettings/settingSlice";
import "@mantine/core/styles.css";
var _ = require("lodash");

dayjs.extend(timezone);

function App() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isAuthenticationInitialized = useAppSelector(
    (state) => state.auth.isAuthInitialized
  );
  const isUserSettingsInitialized = useAppSelector(
    (state) => state.settings.userSettingsInitialized
  );
  const subject = useAppSelector((state) => state.auth.subject);
  const accessToken = useAppSelector((state) => state.auth.access_token);
  const dispatch = useAppDispatch();

  // Fetch user settings once we know the authenticated subject. Auth state and
  // API interceptors are owned by AuthProvider / authService now.
  useEffect(() => {
    if (subject !== "") {
      getUserSettings(subject)
        .then((userSettings) => {
          if (_.isEmpty(userSettings)) {
            dispatch(initializeUserSettings(true));
            toast.warning("User settings doesn't exist");
          } else {
            dispatch(initializeUserSettings(true));
            dispatch(
              setSettings({
                kanbanStartDateTime: userSettings.startDateTime,
                kanbanEndDateTime: userSettings.endDateTime,
                consultingSlot: userSettings.consultingSlot,
                timezone: userSettings.timezone || dayjs.tz.guess(),
              })
            );
            toast.success("Retrieved user settings successfully");
          }
        })
        .catch((error) => {
          dispatch(initializeUserSettings(true));
          toast.error(error.message);
        });
    }
  }, [subject]);

  const renderContent = () => {
    if (!isAuthenticationInitialized) {
      // Still attempting silent refresh on load.
      return <Spin fullscreen={true} spinning={true} />;
    }
    if (!isAuthenticated) {
      return <UnAuthenticatedPage />;
    }
    if (!isUserSettingsInitialized) {
      return <Spin fullscreen={true} spinning={true} />;
    }
    return <BasePage token={accessToken} />;
  };

  return (
    <div>
      {renderContent()}
      <ToastContainer
        position="bottom-right"
        hideProgressBar={true}
        pauseOnFocusLoss={false}
      />
    </div>
  );
}

export default App;
